<template>
  <div class="official-program-manage">
    <div class="header-process">
      <el-input v-model="searchData.rid" placeholder="主播rid" style="width: 200px;"></el-input>
      <el-select v-model="searchData.valid" placeholder="请选择">
        <el-option v-for="item in officialType" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-date-picker v-model="searchData.timeRange" type="datetimerange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      <el-button type="primary" @click="getOfficialList(1)" style="margin-left: 20px;">查询</el-button>
      <el-button type="success" @click="addOfficialHandle">新增</el-button>
    </div>
    <el-table :data="programList" height="700" style="width: 100%;">
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column prop="rid" label="转播主播id"></el-table-column>
      <el-table-column prop="headIcon" label="头像">
        <template slot-scope="scope">
          <img :src="scope.row.headIcon" alt="" style="width: 50px; height: 50px;">
        </template>
      </el-table-column>
      <el-table-column prop="name" label="昵称"></el-table-column>
      <el-table-column prop="agentName" label="代理"></el-table-column>
      <el-table-column prop="startDate" label="开播时间"></el-table-column>
      <el-table-column prop="endDate" label="结束时间"></el-table-column>
      <el-table-column prop="valid" label="是否有效">
        <template slot-scope="scope">
          {{ scope.row.valid === 0 ? '否' : '是' }}
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="创建时间"></el-table-column>
      <el-table-column prop="fixDate" label="操作时间"></el-table-column>
      <el-table-column prop="operator" label="操作人"></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="deleteOfficialProgram(scope.row)"
            v-if="scope.row.valid === 1">删除</el-button>
          <el-button type="danger" size="mini" disabled v-else="scope.row.valid === 0">已删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="searchData.page"
      @current-change="pageChange" :page-size="30">
    </el-pagination>

    <el-dialog title="直播间节目单新增" :visible.sync="dialogData.visible" width="35%" :before-close="handleDialogClose">
      <div class="dialog-update">
        <div>
          <span>官方直播rid</span>
          <el-input v-model="dialogData.data.officialRid" style="width: 200px;"></el-input>
        </div>
        <div>
          <span>转播主播rid</span>
          <el-input v-model="dialogData.data.programRid" style="width: 200px;"></el-input>
        </div>
        <div>
          <span>转播时间</span>

          <el-date-picker v-model="dialogData.data.startDate" type="datetime" placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
          到
          <el-date-picker v-model="dialogData.data.endDate" type="datetime" placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <div>
          <span>是否有效</span>
          <el-switch v-model="dialogData.data.valid" active-text="是" inactive-text="否" :active-value="1"
            :inactive-value="0">
          </el-switch>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" @click="processInfoSubmit" :disabled="addBtnLoad">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getOfficialProgramRoomList, createOfficialProgramRoom, deleteOfficialProgramList } from '@/api/officialRoomRequest.js'
export default {
  data() {
    return {
      addBtnLoad: false,
      // 状态
      officialType: [
        { value: null, label: '全部' },
        { value: 1, label: '有效' },
        { value: 0, label: '无效' },
      ],
      programList: [],
      searchData: {
        rid: null,
        valid: 1,
        startDate: null,
        endDate: null,
        timeRange: [],
        page: 1
      },
      total: 0,
      dialogData: {
        visible: false,
        data: {
          officialRid: '',
          startDate: '',
          endDate: '',
          programRid: '',
          valid: 1
        },

      }
    }
  },
  mounted() {
    this.getOfficialList()
  },
  methods: {
    reqMessageShow(res) {
      if (res.code === 0) {
        this.$message({ type: 'success', message: "操作成功" })
        this.getOfficialList()
      } else {
        this.$message({ type: 'warning', message: res.msg })
      }
    },
    // 获取节目单列表
    async getOfficialList(val) {
      if (!val) {
        this.searchData = {
          rid: null,
          valid: 1,
          startDate: null,
          endDate: null,
          timeRange: [],
          page: 1
        }
      }
      if (val === 1) {
        this.searchData.page = 1
      }
      if (this.searchData.timeRange && this.searchData.timeRange.length === 2) {
        this.searchData.startDate = this.searchData.timeRange[0] + '.000'
        this.searchData.endDate = this.searchData.timeRange[1] + '.000'
      } else {
        this.searchData.startDate = null
        this.searchData.endDate = null
      }
      let submitData = JSON.parse(JSON.stringify(this.searchData))
      delete submitData.timeRange
      const res = await getOfficialProgramRoomList(submitData)
      if (res.code === 0) {
        this.programList = res.data.data
        this.total = res.data.total
        this.$message({ type: 'success', message: "查询成功" })
      } else {
        this.$message.error(res.msg)
        this.programList = []
      }
    },
    pageChange() {
      this.getOfficialList(this.searchData.page)
    },
    // 添加节目单
    addOfficialHandle() {
      this.dialogData.visible = true
      this.dialogData.data = {
        timeRange: [],
        officialRid: '',
        startDate: '',
        endDate: '',
        programRid: '',
        valid: 1
      }
    },

    deleteOfficialProgram(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await deleteOfficialProgramList({ programId: row.programId })
        this.reqMessageShow(res)
      }).catch(() => {

      });
    },
    // 弹窗关闭
    handleDialogClose() {
      this.dialogData.visible = false
    },
    // 操作节目单（增加）
    async processInfoSubmit() {
      this.addBtnLoad = true
      if(new Date(this.dialogData.data.startDate) > new Date(this.dialogData.data.endDate)) {
        this.addBtnLoad = false
        return this.$message.error('开播时间不能大于下播时间')
      }
      if (this.dialogData.data.startDate && this.dialogData.data.endDate) {
        this.dialogData.data.startDate = this.dialogData.data.startDate + '.000'
        this.dialogData.data.endDate = this.dialogData.data.endDate + '.000'
      }
      
      const submitData = JSON.parse(JSON.stringify(this.dialogData.data))
      const res = await createOfficialProgramRoom(submitData)
      this.addBtnLoad = false
      this.reqMessageShow(res)
      this.dialogData.visible = false
    }
  }
}
</script>
<style scoped lang="scss">
.official-program-manage {
  .header-process {
    display: flex;
    align-items: center;

    .el-select {
      margin: 0 20px;
    }
  }
}

.dialog-update {
  &>div {
    margin: 10px 0;

    &>span {
      display: inline-block;
      width: 100px;
      text-align: center;
    }
  }

}
</style>